import { useEffect } from "react";

export default function GlobalScripts() {
  useEffect(() => {
    // particles
    const script1 = document.createElement("script");
    script1.src = "/js/particles.min.js";
    script1.async = true;
    document.body.appendChild(script1);

    // birds
    const script2 = document.createElement("script");
    script2.src = "/js/birds.js";
    script2.async = true;
    document.body.appendChild(script2);
	
	// Disegno Web
    const script3 = document.createElement("script");
    script3.src = "/js/disegnowebologna.js";
    script3.async = true;
    document.body.appendChild(script3);


    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
      document.body.removeChild(script3);
    };
  }, []);

  return null;
}